// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a .logo {
  color: #fff;
  text-decoration: none;
  display: flex;
  align-items: baseline;
  cursor: pointer;
}

.admin_sublogo {
  font-size: 50%;
}

.example-fill-remaining-space {
  flex: 1 1 auto;
}

.pilot-warning {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  z-index: 4;
  min-height: 50px;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/navbar/admin-navbar.component.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAKA;EACI,cAAA;AAFJ;;AAKA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;AAFJ","sourcesContent":["\r\na .logo {\r\n    color: #fff;\r\n    text-decoration: none;\r\n    display: flex;\r\n    align-items: baseline;\r\n    cursor: pointer;\r\n}\r\n\r\n.admin_sublogo{\r\n    font-size: 50%;\r\n    \r\n}\r\n\r\n\r\n.example-fill-remaining-space {\r\n    flex: 1 1 auto;\r\n }\r\n\r\n.pilot-warning{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 8px 16px;\r\n    z-index: 4;\r\n    min-height: 50px;\r\n }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
